const normalizeFieldErrorMessage = error => {
  const errors = Array.isArray(error) ? error : [error];

  return errors
    .map(item => {
      if (typeof item === "string") {
        return item;
      }

      return item?.message || "";
    })
    .filter(Boolean)
    .join(", ");
};

const getFormFieldErrors = ({ errors, form, scope }) => {
  if (!errors || typeof errors !== "object" || !form) {
    return {};
  }

  const errorSources = [];
  const scopedErrors = scope ? errors[scope] : null;

  if (scopedErrors && typeof scopedErrors === "object") {
    errorSources.push(scopedErrors);
  }

  // Keep supporting the old response shape where field errors were placed directly in errors.
  errorSources.push(errors);

  return errorSources.reduce((result, source) => {
    Object.keys(source).forEach(fieldName => {
      if (result[fieldName] || !Object.prototype.hasOwnProperty.call(form, fieldName)) {
        return;
      }

      const message = normalizeFieldErrorMessage(source[fieldName]);

      if (message) {
        result[fieldName] = message;
      }
    });

    return result;
  }, {});
};

const applyFormFieldErrors = ({ errors, form, scope, store, gridName }) => {
  const fieldErrors = getFormFieldErrors({ errors, form, scope });
  const fieldNames = Object.keys(fieldErrors);

  if (fieldNames.length === 0) {
    return 0;
  }

  fieldNames.forEach(fieldName => {
    store.commit("updateFormField", {
      grid_name: gridName,
      field: fieldName,
      value: { ...form[fieldName], invalid: true },
    });
  });

  store.commit("updateFormField", {
    grid_name: gridName,
    field: "invalid_fields",
    value: { ...(form.invalid_fields || {}), ...Object.fromEntries(fieldNames.map(fieldName => [fieldName, true])) },
  });

  store.commit("updateFormField", {
    grid_name: gridName,
    field: "invalid_fields_errors",
    value: { ...(form.invalid_fields_errors || {}), ...fieldErrors },
  });

  return fieldNames.length;
};

module.exports = {
  applyFormFieldErrors,
  getFormFieldErrors,
  normalizeFieldErrorMessage,
};
